<div 
	class="bb-upload-status-box"
	[class.expanded]="expanded"
	draggable="x" contain="screen"
	>
	<div class="bb-upload-status-header">
		
		<span class="total-percentage" [hidden]="uploadService.getCountByStatus('started') === 0 || !totalPercentage">{{ totalPercentage | percentage : 1 }}</span>
		
		<span class="close-upload-box" (click)="hideUploadBox()" [hidden]="uploadService.getCountByStatus('pending') !== 0"><i class="fa fa-times"></i></span>
		
		<span class="minimize-button" (click)="expanded = !expanded">
			<span [hidden]="!expanded"><i class="fa fa-window-minimize"></i></span>
			<span [hidden]="!!expanded"><i class="fa fa-window-maximize"></i></span>
		</span>
		
		<span class="status">{{ status }}</span>
		
		<div class="progress-indicator" [hidden]="uploadService.getCountByStatus('started') === 0" [style.width]="totalPercentage | percentage : 1"></div>
	</div>
	
	<div class="bb-upload-status-body" [hidden]="!expanded">
		<!-- (uploadIdentifier, file) -->
		<div *ngFor="let file of uploadService.fileReference | objectAsArray" 
			[hidden]="file.hidden" 
			class="upload-item status-{{ file.YouTube_status || file.status || file.Facebook_status }}" 
			[class.busy]="file.status === 'running' || file.YouTube_status === 'pending' || (file.Facebook_status && file.status === 'new') || (file.type === 'ProcessItem' && file.status === 'processing')"
			(mousedown)="$event.stopPropagation()"
		>
			<div *ngIf="file?.type !== 'ImportItem' && file?.type !== 'MediaClip' && file?.type !== 'ProcessItem'" class="progress-indicator" [style.width.%]="(file.uploaded / file.size) * 100"></div>
			<div *ngIf="(file?.type === 'ProcessItem' || file?.type === 'ImportItem') && file?.progressPercentage" class="progress-indicator" [style.width.%]="file?.progressPercentage"></div>
			<div class="upload-item-top">
				<span [hidden]="!(file?.uploaded && file?.status !== 'cancelled')" class="file-percentage">{{ file.uploaded / file.size | percentage : 1 }}</span>
				
				<span [hidden]="file?.type !== 'ImportItem' || !file?.progressPercentage" class="file-percentage">{{ file?.progressPercentage }}%</span>
				
				<span [hidden]="file?.status !== 'cancelled'" class="file-percentage">{{ "CANCELLED" | translate }}</span>
				
				<span [hidden]="!file?.name && !file?.label && !file?.srcUrl" class="file-name">{{ file.name || file.label || file.srcUrl }}</span>

				<span *ngIf="file?.type === 'MediaClip'" class="file-name">{{ file.title || file.originalfilename }}</span>

				<span *ngIf="file?.targetClip" class="file-name">{{ file?.targetClip?.title || file?.targetClip?.originalfilename }}</span>
			</div>
			<div class="upload-item-bottom">
				<span [hidden]="file?.status !== 'started' || !file.uploaded" class="file-size-remaining">{{ file.uploaded | fileSize }} / {{ file.size | fileSize }}</span>
				<span [hidden]="!file?.timeRemaining || file.status !== 'started'" class="file-time-remaining">{{ file.timeRemaining | seconds }} {{ 'REMAINING' | translate }}</span>
				<span [hidden]="file?.status !== 'pending'" class="file-time-remaining">{{ 'QUEUED' | translate }}</span>
				
				<span [hidden]="!(file.uploaded && file.status === 'completed')" class="file-size-remaining">{{ file.size | fileSize }}</span>
				<span [hidden]="file.status !== 'completed'" class="file-finished">{{ 'FINISHED' | translate }}</span>

				<ng-container *ngIf="file?.type === 'ImportItem' && !file?.existing">
					<span *ngIf="file?.src && file?.externalId" class="file-source">{{ file.src | titlecase }} : {{ file.externalId }}</span>
					<div class="file-status">
						<span *ngIf="file?.status">{{ ( file.status === 'new' ? 'QUEUED' : file.status) | uppercase | translate }}</span>
						<span *ngIf="file?.status === 'error' && file?.message?.code && file.message.code !== 'UNKNOWN_ERROR'"> ({{ file.message.code | translate }})</span>
					</div>
				</ng-container>

				<ng-container *ngIf="file?.type === 'ImportItem' && file?.existing">
					<span *ngIf="file?.src && file?.externalId" class="file-source" [innerHTML]="'CLIP_ALREADY_IMPORTED' | translate: {src: file.src | titlecase }"></span>
				</ng-container>
				
				<ng-container *ngIf="file?.type === 'MediaClip' && file?.YouTube_status">
					<span class="file-source">YouTube</span>
					<span *ngIf="file?.YouTube_status !== 'pending'" class="file-status">{{ ( !file.YouTube_status ? 'QUEUED' : file.YouTube_status) | uppercase | translate }}</span>
					<span *ngIf="file?.YouTube_status === 'pending'" class="file-status">{{ 'UPLOADING' | uppercase | translate }}</span>
				</ng-container>

				<ng-container *ngIf="file?.type === 'MediaClip' && file?.Facebook_status">
					<span class="file-source">Facebook</span>
					<span *ngIf="file?.status === 'uploading'" class="file-status">{{ ( !file.status ? 'QUEUED' : file.status) | uppercase | translate }}</span>
					<span *ngIf="file?.status === 'exported'" class="file-status">{{ 'EXPORTED' | uppercase | translate }}</span>
				</ng-container>

				<ng-container *ngIf="file?.type === 'MediaClip' && file?.Instagram_status">
					<span class="file-source">Instagram</span>
					<span *ngIf="file?.status === 'uploading'" class="file-status">{{ ( !file.status ? 'QUEUED' : file.status) | uppercase | translate }}</span>
					<span *ngIf="file?.status === 'exported'" class="file-status">{{ 'EXPORTED' | uppercase | translate }}</span>
				</ng-container>
				
				<ng-container *ngIf="file?.type === 'ProcessItem'">
					<span class="file-source">Trimming</span>
					<span *ngIf="file?.status !== 'pending'" class="file-status">{{ ( !file?.status ? 'QUEUED' : file.status) | uppercase | translate }}</span>
				</ng-container>
				
			</div>
			
			<div class="actions">
				<a *ngIf="file && file?.status !== 'error' && file?.status !== 'cancelled' && file?.extraParams?.type === 'mediaclip' && file?.extraParams?.mediaclipId > 0 && file?.mediaclip?.usetype !== 'commercial'"
					class="button"
					[routerLink]="['/library/mediaclip/', file?.extraParams?.mediaclipId, 'metadata']">
					<i class="fa fa-pencil-square-o"></i>{{ 'EDIT_MEDIACLIP' | translate }}
				</a>

				<a *ngIf="file && file?.status !== 'error' && file?.status !== 'cancelled' && file?.extraParams?.type === 'mediaclip' && file?.extraParams?.mediaclipId > 0 && file?.mediaclip?.usetype === 'commercial'"
					class="button"
					[routerLink]="['/adservices/vastservice/creatives/', file?.extraParams?.mediaclipId, 'metadata']">
					<i class="fa fa-pencil-square-o"></i>{{ 'EDIT_CREATIVE' | translate }}
				</a>

				<a *ngIf="file && file?.type === 'ImportItem' && file?.status !== 'error' && file?.oid && file?.usetype === 'editorial'"
					class="button"
					[routerLink]="['/library/mediaclip/', file?.oid, 'metadata']">
					<i class="fa fa-pencil-square-o"></i>{{ 'EDIT_MEDIACLIP' | translate }}
				</a>
				
				<a *ngIf="file?.type === 'ProcessItem'"
					class="button"
					[routerLink]="['/library/mediaclip/', file?.id, 'metadata']">
					<i class="fa fa-pencil-square-o"></i>{{ 'EDIT_MEDIACLIP' | translate }}
				</a>

				<a *ngIf="file && file?.type === 'ImportItem' && file?.status !== 'error' && file?.oid && file?.usetype === 'commercial'"
					class="button"
					[routerLink]="['/adservices/vastservice/creatives/', file?.oid, 'metadata']">
					<i class="fa fa-pencil-square-o"></i>{{ 'EDIT_CREATIVE' | translate }}
				</a>

				<a *ngIf="file && file?.type === 'MediaClip' && file?.id"
					class="button"
					[routerLink]="['/library/mediaclip/', file?.id, 'social']">
					<i class="fa fa-pencil-square-o"></i>{{ 'EDIT_MEDIACLIP' | translate }}
				</a>

				<!-- Implement later: -->
				<button *ngIf="file?.type !== 'ProcessItem'" [hidden]="file.status !== 'started'" type="button" class="button" (click)="cancel(file)"><i class="fa fa-ban"></i>{{ 'CANCEL' | translate }}</button>
				<button [hidden]="file.status === 'pending'" type="button" class="button right icon-only" (click)="file.hidden = true"><i class="fa fa-times"></i></button>
			</div>
		</div>
	</div>
	<!-- Implement later: -->
	<div class="bb-upload-status-footer" [hidden]="!expanded">
		<span class="total-time-remaining" [hidden]="uploadService.getCountByStatus('started') === 0">{{ uploadService.getTimeRemaining() | seconds }} {{ "UNTIL_FINISHED" | translate }}</span>
		<span class="average-speed" [hidden]="uploadService.getCountByStatus('started') === 0">{{ totalUploadSpeed | fileSize:'/s' }}</span>
		
		<span class="total-time-remaining" [hidden]="uploadService.getCountByStatus('completed') !== uploadService.getVisibleCount()">{{ "FINISHED_IN" | translate }} {{ uploadService.getTimeElapsed() | seconds }}</span>
		<span class="average-speed" [hidden]="uploadService.getCountByStatus('started') > 0 || uploadService.getVisibleCount() === 0">{{ uploadService.getAvgUploadSpeed() | fileSize:'/s' }} {{ "UPLOAD_AVERAGE" | translate }}</span>		
	</div>
</div>
